import type { Address } from 'domains/addresses';
import type { ShippingMethod } from 'domains/shipping_methods';
import type { CountryCode } from 'libphonenumber-js';
import type { StrictUnion } from 'types/common_types';

export type CartShippingMethod = {
  shipping_method_api_id: number;
  name: string;
  recipient: string;
  street_address: string;
  street_address_secondary?: string;
  city: string;
  state_or_region: string;
  country: CountryCode;
  postal_code: string;
  phone_number: string;
};

export type CartPickupMethod = {
  shipping_method_api_id: number;
  name: string;
  recipient: string;
};

export type SavedCartShipping = StrictUnion<CartShippingMethod | CartPickupMethod> | null;

export type AddressValidationConfirmation = 'original' | 'suggested';

export type SaveShippingAddressPayload = Address & { method: ShippingMethod };

export type SaveShippingMethodPayload = { id: number; recipient?: string };
